// extracted by mini-css-extract-plugin
export default {"_":"Error____vsVGt","title":"Error_title__vGNeq","code":"Error_code__7O2Gu","bigCode":"Error_bigCode__6X7Vk","goBack":"Error_goBack__FQLkO"};